import ActionType from '../constants/ActionType';
import { RootActionTypes } from '../../../stores/types';

export default function showExportDialog(): RootActionTypes {
  return {
    type: ActionType.ShowExportDialog,
  };
}
